// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"849":"dd864a95","5205":"9edd031d","6116":"72846e13","7986":"32b1fd33","8867":"72d86e09","8941":"e7dea47b","9242":"9edd031d","9713":"9edd031d"}[chunkId] + ".chunk.css";
};